module.exports = __webpack_public_path__ + "img/Padlock.0ff5aeff.svg";